module.exports = __webpack_public_path__ + "img/fk.2128a387.png";